import React, { useState, useEffect, createContext, ReactNode } from 'react';
import { RobotTableData } from 'react-components';
interface FollowingRobotProviderProps {
  children: ReactNode;
}

export const FollowingRobotContext = createContext<
  | {
      followingRobot: RobotTableData | null;
      setFollowingRobot: (robot: RobotTableData | null) => void;
    }
  | undefined
>(undefined);

const FollowingRobotProvider: React.FC<FollowingRobotProviderProps> = ({ children }) => {
  const [followingRobot, setFollowingRobot] = useState<RobotTableData | null>(null);

  useEffect(() => {
    const storedRobot = localStorage.getItem('followingRobot');
    if (storedRobot) {
      setFollowingRobot(JSON.parse(storedRobot));
    }
  }, []);

  // Ensure any change to followingRobot is saved to local storage, track regardless of component/micro app
  useEffect(() => {
    if (followingRobot) {
      localStorage.setItem('followingRobot', JSON.stringify(followingRobot));
    } else {
      localStorage.removeItem('followingRobot');
    }
  }, [followingRobot]);

  return (
    <FollowingRobotContext.Provider value={{ followingRobot, setFollowingRobot }}>
      {children}
    </FollowingRobotContext.Provider>
  );
};

export default FollowingRobotProvider;
